<template>
  <AnalyticsUpselling v-if="!entitlementsStore.can('teamAnalytics')" />
  <AnalyticsWrapper v-else />
</template>
<script lang="ts" setup>
import { onMounted } from 'vue';
import { TrackClickEvents, useTrack } from '@/composables/useTrack';
import { useEntitlementsStore } from '@/store/useEntitlementsStore';

import AnalyticsWrapper from './AnalyticsWrapper.vue';
import AnalyticsUpselling from './AnalyticsUpselling.vue';

const entitlementsStore = useEntitlementsStore();
const { trackClick } = useTrack();

onMounted(() => trackClick(TrackClickEvents.VIEWER_ANALYTICSTAB));
</script>
